<template>
  <div class="inspection-main">
    <div class="inspection-wrap">
      <header class="header">
        <div class="logo">
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745819464041_header-title-bj.png" />
        </div>
      </header>

      <infoBar @gotoPage="gotoPage" :inspectionData="props.inspectionData" />

      <div class="content">
        <div class="detail">
          <div class="gs-form">
            <el-form :model="formDataMain" ref="elFormRef" inline-message scroll-to-error :scroll-into-view-options="{ behavior: 'smooth', block: 'center' }">
              <!-- 基本信息 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td class="table-label">报告年度</td>
                    <td colspan="3">
                      <el-form-item>
                        <el-input v-model.trim="reportData.reportYear" disabled />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td width="217" class="table-label">企业名称</td>
                    <td width="327">
                      <el-form-item>
                        <el-input v-model.trim="checkRule.companyName" disabled />
                      </el-form-item>
                    </td>
                    <td width="217" class="table-label">统一社会信用代码/注册号</td>
                    <td>
                      <el-form-item>
                        <el-input v-model.trim="checkRule.creditCode" disabled />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">企业通信地址</td>
                    <td>
                      <el-form-item prop="base.data.addr" :rules="rulesConfig">
                        <el-input type="textarea" autosize v-model.trim="formDataMain.base.data.addr" disabled />
                      </el-form-item>
                    </td>
                    <td class="table-label">邮政编码</td>
                    <td>
                      <el-form-item prop="base.data.postalcode" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.postalcode" disabled />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">企业联系电话</td>
                    <td>
                      <el-form-item prop="base.data.tel" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.tel" disabled />
                      </el-form-item>
                    </td>
                    <td class="table-label">电子邮箱</td>
                    <td>
                      <el-form-item prop="base.data.email" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.email" disabled />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">企业经营状态</td>
                    <td>
                      <el-form-item prop="base.data.busst" :rules="rulesConfig">
                        <el-select v-model="formDataMain.base.data.busst" disabled>
                          <el-option v-for="(item, index) of busstOptions" :key="index" :label="item.label" :value="item.value" />
                        </el-select>
                      </el-form-item>
                    </td>
                    <td class="table-label">企业控股</td>
                    <td>
                      <el-form-item prop="base.data.holdingsmsg" :rules="rulesConfig">
                        <el-select v-model="formDataMain.base.data.holdingsmsg" disabled>
                          <el-option v-for="(item, index) of holdingsmsgOptions" :key="index" :label="item.label" :value="item.value" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">企业主营业务活动</td>
                    <td colspan="3">
                      <el-form-item prop="base.data.mainbusiact" :rules="rulesConfig">
                        <el-input type="textarea" autosize v-model.trim="formDataMain.base.data.mainbusiact" disabled />
                      </el-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- 充装单位许可证 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="224" class="table-label" :rowspan="formDataMain.license.data.length + 1">充装单位许可证</td>
                    <td width="178" class="table-label">许可名称</td>
                    <td width="224" class="table-label">许可编号</td>
                    <td width="224" class="table-label">有效期自</td>
                    <td class="table-label">有效期至</td>
                  </tr>
                </tbody>
              </table>
              <!-- 股东及出资信息 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="131" class="table-label" :rowspan="formDataMain.share.data.length + 1">股东发起人出资情况表（万元，币种应与注册资本币种一致）</td>
                    <td width="131" class="table-label">股东</td>
                    <td width="76" class="table-label">认缴出资额</td>
                    <td width="176" class="table-label">认缴出资时间</td>
                    <td width="176" class="table-label">认缴出资方式</td>
                    <td width="131" class="table-label">实缴出资额</td>
                    <td width="86" class="table-label">实缴出资时间</td>
                    <td class="table-label">实缴出资方式</td>
                  </tr>
                  <tr v-for="(item, index) of formDataMain.share.data" :key="index">
                    <td>{{ item.invname }}</td>
                    <td>{{ item.lisubconam }}</td>
                    <td>{{ item.subcondate }}</td>
                    <td>{{ getLabel(item.subconform, subconformOptions) }}</td>
                    <td>{{ item.liacconam }}</td>
                    <td>{{ item.accondate }}</td>
                    <td>{{ getLabel(item.acconform, subconformOptions) }}</td>
                  </tr>
                </tbody>
              </table>
              <!-- 网站或网店信息 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="224" class="table-label" :rowspan="formDataMain.site.data.length + 1">是否有网站或网店</td>
                    <td width="87" :rowspan="formDataMain.site.data.length + 1">{{ formDataMain.site.data.length > 0 ? "是" : "否" }}</td>
                    <td width="224" class="table-label">类型</td>
                    <td width="224" class="table-label">名称</td>
                    <td class="table-label">网站</td>
                  </tr>
                  <tr v-for="(item, index) of formDataMain.site.data" :key="index">
                    <td>
                      <div class="td-c">
                        <el-select v-model="item.webtype" disabled>
                          <el-option v-for="(item, index) of webtypeOptions" :key="index" :label="item.label" :value="item.value" />
                        </el-select>
                      </div>
                    </td>
                    <td>{{ item.websitname }}</td>
                    <td>{{ item.website }}</td>
                  </tr>
                </tbody>
              </table>
              <!-- 股权变更信息 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="224" class="table-label" :rowspan="formDataMain.change.data.length + 1">有限责任公司本年度是否有股权转让</td>
                    <td width="87" :rowspan="formDataMain.change.data.length + 1">{{ formDataMain.change.data.length > 0 ? "是" : "否" }}</td>
                    <td width="178" class="table-label">股东</td>
                    <td width="178" class="table-label">变更前股权比例</td>
                    <td width="178" class="table-label">变更后股权比例</td>
                    <td class="table-label">股权变更日期</td>
                  </tr>
                  <tr v-for="(item, index) of formDataMain.change.data" :key="index">
                    <td>{{ item.inv }}</td>
                    <td>{{ item.transampr }}%</td>
                    <td>{{ item.transamaft }}%</td>
                    <td>{{ item.altdate }}</td>
                  </tr>
                </tbody>
              </table>
              <!-- 对外投资信息 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="224" class="table-label" :rowspan="formDataMain.invest.data.length + 1">企业是否有股权信息或购买其它公司股权</td>
                    <td width="87" :rowspan="formDataMain.invest.data.length + 1">{{ formDataMain.invest.data.length > 0 ? "是" : "否" }}</td>
                    <td width="453" class="table-label">投资设立企业后购买股权企业名称</td>
                    <td class="table-label">统一社会信用代码/注册号</td>
                  </tr>
                </tbody>
              </table>
              <!-- 资产状况信息 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="215" class="table-label" rowspan="8">资产状况信息（币种：人民币）</td>
                    <td width="213" class="table-label">
                      <p class="t-align-r pr-6">资产总额</p>
                    </td>
                    <td width="370">
                      <el-form-item prop="assert.data.assgro" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.assert.data.assgro" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td width="370">
                      <el-form-item prop="assert.data.assgrodis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.assert.data.assgrodis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">所有者权益合计</p>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.totequ" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.assert.data.totequ" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.totequdis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.assert.data.totequdis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">营业总收入</p>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.vendinc" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.assert.data.vendinc" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.vendincdis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.assert.data.vendincdis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">其中：主营业收入</p>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.maibusinc" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.assert.data.maibusinc" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.maibusincdis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.assert.data.maibusincdis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">利润总额</p>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.progro" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.assert.data.progro" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.progrodis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.assert.data.progrodis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">净利润</p>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.netinc" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.assert.data.netinc" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.netincdis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.assert.data.netincdis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">纳税总额</p>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.ratgro" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.assert.data.ratgro" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.ratgrodis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.assert.data.ratgrodis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">负债总额</p>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.liagro" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.assert.data.liagro" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="assert.data.liagrodis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.assert.data.liagrodis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- 对外担保信息 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="143" class="table-label" :rowspan="formDataMain.guaranty‌.data.length + 1">对外提供保证担保信息</td>
                    <td width="94" class="table-label">债权人</td>
                    <td width="94" class="table-label">债务人</td>
                    <td width="94" class="table-label">主债权种类</td>
                    <td width="94" class="table-label">主债权种类额</td>
                    <td width="143" class="table-label">履行债务的期限</td>
                    <td width="94" class="table-label">保证的期间</td>
                    <td width="143" class="table-label">保证的方式</td>
                    <td class="table-label">公示状态</td>
                  </tr>
                </tbody>
              </table>
              <!-- 从业人数 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="100" class="table-label">从业人数</td>
                    <td width="218">
                      <el-form-item prop="base.data.empnum" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.empnum" disabled>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td width="163">
                      <el-form-item prop="base.data.empnumdis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.base.data.empnumdis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                    <td width="203" class="table-label">其中女性从业人数</td>
                    <td width="218">
                      <el-form-item prop="base.data.womempnum" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.womempnum" disabled>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="base.data.womempnumdis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.base.data.womempnumdis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- 社保信息 -->
              <!-- 参保各险种人数 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="223" class="table-label" rowspan="5">参保各险种人数</td>
                    <td width="327" class="table-label">
                      <p class="t-align-r pr-6">城镇职工基本养老保险</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.so110" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.so110" disabled>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">失业保险</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.so210" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.so210" disabled>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">职工基本医疗保险</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.so310" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.so310" disabled>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">工伤保险</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.so410" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.so410" disabled>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">生育保险</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.so510" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.so510" disabled>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- 单位缴费基数 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="183" class="table-label" rowspan="4">单位缴费基数</td>
                    <td width="287" class="table-label">
                      <p class="t-align-r pr-6">单位参加城镇职工基本养老保险缴费基数</p>
                    </td>
                    <td width="338">
                      <el-form-item prop="social.data.totalwagesSo110" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.totalwagesSo110" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td rowspan="4">
                      <el-form-item prop="social.data.totalwagesdis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.social.data.totalwagesdis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">单位参加失业保险缴费基数</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.totalwagesSo210" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.totalwagesSo210" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">单位参加职工基本医疗保险缴费基数</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.totalwagesSo310" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.totalwagesSo310" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">单位参加生育保险缴费基数</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.totalwagesSo510" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.totalwagesSo510" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- 本期实际缴费金额 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="177" class="table-label" rowspan="5">本期实际缴费金额</td>
                    <td width="312" class="table-label">
                      <p class="t-align-r pr-6">参加城镇职工基本养老保险本期实际缴费金额</p>
                    </td>
                    <td width="328">
                      <el-form-item prop="social.data.totalpaymentSo110" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.totalpaymentSo110" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td rowspan="5">
                      <el-form-item prop="social.data.totalpaymentdis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.social.data.totalpaymentdis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">参加失业保险本期实际缴费金额</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.totalpaymentSo210" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.totalpaymentSo210" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">参加职工基本医疗保险本期实际缴费金额</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.totalpaymentSo310" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.totalpaymentSo310" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">参加工伤保险本期实际缴费金额</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.totalpaymentSo410" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.totalpaymentSo410" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">参加生育保险本期实际缴费金额</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.totalpaymentSo510" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.totalpaymentSo510" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- 单位累计欠缴金额 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="177" class="table-label" rowspan="5">单位累计欠缴金额</td>
                    <td width="312" class="table-label">
                      <p class="t-align-r pr-6">单位参加城镇职工基本养老保险累计欠缴金额</p>
                    </td>
                    <td width="328">
                      <el-form-item prop="social.data.unpaidsocialinsSo110" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.unpaidsocialinsSo110" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td rowspan="5">
                      <el-form-item prop="social.data.unpaidsocialinsdis" :rules="rulesConfig">
                        <el-select v-model="formDataMain.social.data.unpaidsocialinsdis" disabled>
                          <el-option label="选择公示" value="1" />
                          <el-option label="选择不公示" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">单位参加失业保险累计欠缴金额</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.unpaidsocialinsSo210" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.unpaidsocialinsSo210" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">单位参加职工基本医疗保险累计欠缴金额</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.unpaidsocialinsSo310" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.unpaidsocialinsSo310" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">单位参加工伤保险累计欠缴金额</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.unpaidsocialinsSo410" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.unpaidsocialinsSo410" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">单位参加生育保险累计欠缴金额</p>
                    </td>
                    <td>
                      <el-form-item prop="social.data.unpaidsocialinsSo510" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.social.data.unpaidsocialinsSo510" disabled>
                          <template #append>万元</template>
                        </el-input>
                      </el-form-item>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- 其中人数 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="145" class="table-label" rowspan="4">其中</td>
                    <td width="154" class="table-label">
                      <p class="t-align-r pr-6">高校毕业生人数</p>
                    </td>
                    <td width="336">
                      <el-form-item prop="base.data.colgranum" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.colgranum" disabled>
                          <template #prepend>经营者</template>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td width="323">
                      <el-form-item prop="base.data.colemplnum" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.colemplnum" disabled>
                          <template #prepend>雇员</template>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>选择不公示</td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">退役士兵人数</p>
                    </td>
                    <td>
                      <el-form-item prop="base.data.retsolnum" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.retsolnum" disabled>
                          <template #prepend>经营者</template>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="base.data.retemplnum" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.retemplnum" disabled>
                          <template #prepend>雇员</template>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>选择不公示</td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">残疾人人数</p>
                    </td>
                    <td>
                      <el-form-item prop="base.data.dispernum" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.dispernum" disabled>
                          <template #prepend>经营者</template>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="base.data.disemplnum" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.disemplnum" disabled>
                          <template #prepend>雇员</template>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>选择不公示</td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">失业人员再就业人数</p>
                    </td>
                    <td>
                      <el-form-item prop="base.data.unenum" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.unenum" disabled>
                          <template #prepend>经营者</template>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item prop="base.data.uneemplnum" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.base.data.uneemplnum" disabled>
                          <template #prepend>雇员</template>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>选择不公示</td>
                  </tr>
                </tbody>
              </table>
              <!-- 党建信息 -->
              <table class="table-form">
                <tbody>
                  <tr>
                    <td width="252" class="table-label" rowspan="4">党建信息</td>
                    <td width="274" class="table-label">
                      <p class="t-align-r pr-6">中共党员（包括预备党员）人数</p>
                    </td>
                    <td width="441">
                      <el-form-item prop="party.data.numparm" :rules="rulesConfig">
                        <el-input v-model.trim="formDataMain.party.data.numparm" disabled>
                          <template #append>人</template>
                        </el-input>
                      </el-form-item>
                    </td>
                    <td>选择不公示</td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">党组织建制</p>
                    </td>
                    <td>
                      <el-form-item prop="party.data.parins" :rules="rulesConfig">
                        <el-select v-model="formDataMain.party.data.parins" disabled>
                          <el-option v-for="(item, index) of parinsOptions" :key="index" :label="item.label" :value="item.value" />
                        </el-select>
                      </el-form-item>
                    </td>
                    <td>选择不公示</td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">经营者是否为党员</p>
                    </td>
                    <td>
                      <el-form-item prop="party.data.resparmsign" :rules="rulesConfig">
                        <el-select v-model="formDataMain.party.data.resparmsign" disabled>
                          <el-option label="是" value="1" />
                          <el-option label="否" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                    <td>选择不公示</td>
                  </tr>
                  <tr>
                    <td class="table-label">
                      <p class="t-align-r pr-6">经营者是否为党组织书记</p>
                    </td>
                    <td>
                      <el-form-item prop="party.data.resparsecsign" :rules="rulesConfig">
                        <el-select v-model="formDataMain.party.data.resparsecsign" disabled>
                          <el-option label="是" value="1" />
                          <el-option label="否" value="2" />
                        </el-select>
                      </el-form-item>
                    </td>
                    <td>选择不公示</td>
                  </tr>
                </tbody>
              </table>
            </el-form>
          </div>
        </div>

        <div class="btns">
          <el-button type="primary" color="#d1ab62" size="large" @click="warn()">预览打印</el-button>
          <el-button type="primary" color="#d1ab62" size="large" @click="submit">提交并公示</el-button>
          <el-button type="primary" color="#d1ab62" size="large" @click="gotoPage('form')">返回修改</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import { cloneDeep } from "lodash";
import { $emit, $on } from "vue-happy-bus";
import infoBar from "../cmp/infoBar.vue";
import { busstOptions, holdingsmsgOptions, subconformOptions, webtypeOptions, parinsOptions, getLabel } from "../cmp/mainForm/utils.js";

const props = defineProps({
  inspectionData: {
    required: true,
    type: Object,
  },
});

const checkRule = inject("checkRule");

const { reportData, formDataMain } = props.inspectionData;

const rulesConfig = { required: true, trigger: ["blur", "change"], message: "不能为空" };

const elFormRef = ref();
const submit = () => {
  elFormRef.value.validate((isValid) => {
    if (isValid) {
      const inspectionDataClone = cloneDeep(props.inspectionData);

      inspectionDataClone.reportData.publicDate = dayjs().format("YYYY-MM-DD");
      inspectionDataClone.reportData.publicStatus = 1;
      $emit("inspectionSubmit", inspectionDataClone);
    }
  });
};

const emits = defineEmits(["gotoPage"]);

const gotoPage = (page) => {
  emits("gotoPage", page);
};

function dateCnStr(str) {
  if (dayjs(str).$d != "Invalid Date") {
    return dayjs(str).format("YYYY年MM月DD日");
  }
}

//警告功能
function warn() {
  ElMessageBox.confirm("本系统为教学系统，暂不支持此功能", "信息", {
    showCancelButton: false,
    customStyle: {
      "--el-messagebox-width": "300px",
    },
  }).catch(() => {});
}
</script>

<style scoped lang="scss">
.inspection-main {
  background-color: #fbf8ef;
  display: flex;
  flex-direction: column;
  height: 100%;

  .inspection-wrap {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;

    .header {
      flex: 0 0 auto;
      overflow: hidden;
      border-top: 10px solid #ab812d;
      height: 100px;
      background: #ffffff url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745818808900_bj.png) no-repeat right top;
      border-bottom: 1px solid #e0dddd;

      .logo {
        width: 1200px;
        margin: 0 auto;
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    .content {
      height: 100%;
      overflow: hidden;
      width: 1200px;
      margin: 20px auto;
      background-color: #ffffff;
      padding: 24px 32px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .detail {
        height: 100%;
        overflow: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        padding-right: 10px;

        * {
          pointer-events: none;
        }

        .gs-form {
          position: relative;

          &::before {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 999;
          }

          .table-form {
            margin-bottom: 20px;
            border-collapse: collapse;
            border: 1px solid #ebebeb;
            width: 100%;

            .d-flex {
              display: flex;
            }

            .space-between {
              display: flex;
              justify-content: space-between;
            }

            .d-center-x {
              display: flex;
              justify-content: center;
            }

            .t-align-r {
              text-align: right;
            }

            .pr-6 {
              padding-right: 6px;
            }

            .plr-30 {
              padding-left: 30px;
              padding-right: 30px;
            }

            .el-form-item {
              margin-bottom: 0;

              :deep(.el-form-item__error--inline) {
                width: 100%;
                text-align: center;
                margin: 0;
              }
            }

            td {
              color: #999999;
              border: 1px solid #ebebeb;
              padding: 4px;
              vertical-align: middle;
              text-align: center;
              height: 32px;

              &.table-label {
                background-color: #eae3d8;
                color: #ab812d;
                font-weight: 700;

                * {
                  font-weight: 700;
                }
              }

              .td-c {
                padding: 0 12px;
                display: flex;
                align-items: center;
              }

              :deep() {
                .el-input__wrapper,
                .el-select__wrapper {
                  box-shadow: none;
                  background: none;
                }

                .el-input-group__prepend,
                .el-input-group__append {
                  box-shadow: none;
                  background: none;
                  padding: 0 10px;
                }

                .el-textarea.is-disabled .el-textarea__inner {
                  background: none;
                  box-shadow: none;
                  resize: none;
                }
              }
            }
          }
        }
      }

      .btns {
        flex: 0 0 auto;
        overflow: hidden;
        display: flex;
        justify-content: center;
        margin-top: 10px;

        .el-button {
          color: #ffffff;
          margin: 0 20px;
        }
      }
    }
  }
}
</style>
